import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center p-5 py-10 pt-7 space-y-10" }

import {onMounted, ref} from 'vue';
import {modalController} from "@ionic/vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ProfilePictureSubmittedSheet',
  setup(__props) {


const loading = ref(true)

onMounted(async () => {
  loading.value = false
})

const dismiss = async () => {
  await modalController.dismiss()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", { class: "flex flex-col space-y-6 items-center" }, [
      _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"flex text-brand-lime\"><svg class=\"w-16 h-16 fill-current\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 448 512\"><path d=\"M0 96C0 60.7 28.7 32 64 32H384c35.3 0 64 28.7 64 64V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96zm64 32V320c0 17.7 14.3 32 32 32h16c0-35.3 28.7-64 64-64h96c35.3 0 64 28.7 64 64h16c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H96c-17.7 0-32 14.3-32 32zm96 64a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z\"></path></svg></div><div class=\"flex flex-col w-full items-center space-y-1 px-2\"><div class=\"flex text-white text-2xl font-medium text-center\">Profile Picture</div><div class=\"text-brand-light-gray text-lg text-center leading-tight\">Your profile picture has been submitted for approval. Whilst this is reviewed your current profile picture will remain in place.</div></div>", 2)),
      _createElementVNode("div", { class: "flex flex-col space-y-2 w-full items-center" }, [
        _createElementVNode("button", {
          onClick: dismiss,
          class: "flex w-full bg-brand-lime rounded-full px-8 h-14 font-medium text-xl text-brand-black transition-all"
        }, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("div", { class: "flex m-auto space-x-2.5" }, [
            _createElementVNode("div", { class: "my-auto pt-0.5" }, [
              _createElementVNode("div", null, "Got it!")
            ])
          ], -1)
        ]))])
      ])
    ])
  ]))
}
}

})